<template><div></div> </template>

<script>
import { config } from "../common/apis";
import axios from "axios";
import md5 from "js-md5";
import { Toast } from "vant";
import { mapActions } from "vuex";
export default {
	name: "login",
	props: {},
	components: {},
	data() {
		return {};
	},
	created() {
		this.login();
	},
	computed: {},
	watch: {},
	methods: {
		...mapActions(["syncToken"]),
		login() {
			let userNumber = this.$route.query.employee_code;
			if (!userNumber) {
				Toast("未获取到人员信息，请退出重试");
				return;
			}
			let para = {
				userNumber: userNumber,
				sign: md5(userNumber + config.SALT)
			};
			axios({
				method: "POST",
				url: config.API_BASE_URI + "app/sus/auth/token",
				data: para,
				timeout: 1000 * 60 // 请求超时时间默认60秒
			})
				.then(res => {
					if (res.data.data.authToken) {
						let authToken = res.data.data.authToken;
						this.syncToken({
							authToken: authToken,
							userNumber: userNumber
						});
						sessionStorage.setItem("authToken", authToken);
						sessionStorage.setItem("userNumber", userNumber);
						this.$router.replace("/customerComplaintsList");
					} else {
						Toast(res.data.data.msg);
					}
				})
				.catch(err => {
					Toast(err.message);
				});
		}
	},
	filters: {}
};
</script>

<style scoped></style>
